// Browser-compatible base64url decode function
function base64urlDecode(str) {
  // Add padding if needed
  str += "=".repeat((4 - (str.length % 4)) % 4);
  // Replace URL-safe characters
  str = str.replace(/-/g, "+").replace(/_/g, "/");

  // Decode base64 to binary string
  const binaryString = atob(str);

  // Convert to Uint8Array
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  return bytes;
}
function base64urlEncode(buffer) {
  let binary = "";
  const bytes = new Uint8Array(buffer);
  for (let i = 0; i < bytes.byteLength; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary)
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, ""); // remove padding
}
// Your decrypt function
export async function decryptToken(token) {
  const raw = base64urlDecode(token); // Uint8Array
  const iv = raw.slice(0, 12);
  const cipher = raw.slice(12);

  const keyBytes = base64urlDecode(process.env.REACT_APP_ENCRYPTION_KEY); // Uint8Array
  const cryptoKey = await crypto.subtle.importKey(
    "raw",
    keyBytes,
    { name: "AES-GCM" },
    false,
    ["decrypt"],
  );

  const plainBuffer = await crypto.subtle.decrypt(
    { name: "AES-GCM", iv },
    cryptoKey,
    cipher,
  );

  return new TextDecoder().decode(plainBuffer); // original UUID
}

// Utility: Get and store jdId in sessionStorage
export async function initJdId() {
  const params = new URLSearchParams(window.location.search);
  const jdId = params.get("jdId");
  const companyId = params.get("companyId");

  if (jdId) {
    try {
      const decrypted = await decryptToken(jdId);
      sessionStorage.setItem("jdId", decrypted);
    } catch (err) {
      console.error("Failed to decrypt jdId:", err);
    }
  }
  if (companyId) {
    try {
      const decryptedCompanyId = await decryptToken(companyId);
      sessionStorage.setItem("companyId", decryptedCompanyId);
    } catch (err) {
      console.error("Failed to decrypt jdId:", err);
    }
  }
}

export async function encryptToken(plainText) {
  const encoder = new TextEncoder();
  const data = encoder.encode(plainText);

  // Decode the base64url key
  const keyBytes = base64urlDecode(process.env.REACT_APP_ENCRYPTION_KEY);

  // Import the AES-GCM key
  const cryptoKey = await crypto.subtle.importKey(
    "raw",
    keyBytes,
    { name: "AES-GCM" },
    false,
    ["encrypt"],
  );

  // Generate random IV (12 bytes)
  const iv = crypto.getRandomValues(new Uint8Array(12));

  // Encrypt
  const cipherBuffer = await crypto.subtle.encrypt(
    { name: "AES-GCM", iv },
    cryptoKey,
    data,
  );

  // Combine IV + cipher text
  const combined = new Uint8Array(iv.byteLength + cipherBuffer.byteLength);
  combined.set(iv, 0);
  combined.set(new Uint8Array(cipherBuffer), iv.byteLength);

  // Return base64url encoded token
  return base64urlEncode(combined);
}

export async function initInterviewId() {
  const params = new URLSearchParams(window.location.search);

  const interviewId = params.get("assessmentId");
  const companyId = params.get("companyId");
  const isPhoneToken = params.get("isPhone"); // encrypted isPhone flag

  if (interviewId) {
    try {
      const decrypted = await decryptToken(interviewId);
      sessionStorage.setItem("interviewId", decrypted);
    } catch (err) {
      console.error("Failed to decrypt interviewId:", err);
    }
  }

  if (companyId) {
    try {
      const decryptedCompanyId = await decryptToken(companyId);
      sessionStorage.setItem("companyId", decryptedCompanyId);
    } catch (err) {
      console.error("Failed to decrypt companyId:", err);
    }
  }

  // 🔹 NEW PART
  if (isPhoneToken) {
    try {
      const decryptedIsPhone = await decryptToken(isPhoneToken);
      sessionStorage.setItem("isPhone", decryptedIsPhone);
    } catch (err) {
      console.error("Failed to decrypt isPhone:", err);
    }
  }
}
export async function initSlotBooking() {
  const params = new URLSearchParams(window.location.search);

  const companyId = params.get("companyId");
  const jdId = params.get("jdId");
  const slotBookfromReset = params.get("slotBookfromReset");

  if (companyId) {
    try {
      const decryptedCompanyId = await decryptToken(companyId);
      sessionStorage.setItem("companyId", decryptedCompanyId);
    } catch (err) {
      console.warn("Failed to decrypt companyId, storing raw value:", err);
      sessionStorage.setItem("companyId", companyId);
    }
  }

  if (jdId) {
    try {
      const decryptedjdId = await decryptToken(jdId);
      sessionStorage.setItem("jdId", decryptedjdId);
    } catch (err) {
      console.warn("Failed to decrypt jdId, storing raw value:", err);
      sessionStorage.setItem("jdId", jdId);
    }
  }
  if (slotBookfromReset) {
    sessionStorage.setItem(
      "slotBookfromReset",
      slotBookfromReset?.toLowerCase() === "true" ? "true" : "false",
    );
  }
}
// Utility: Fetch jdId anywhere
export function getJdId() {
  return sessionStorage.getItem("jdId");
}
